<template>
    <div class="bckdiv xyz">
      <v-container fluid fill-height>
          <v-layout align-center justify-center style="margin-top:90px">
              <v-flex xs12 md8>
                  <v-card flat class="elevation-5">
                      <h2 style="text-align:center;padding-top:20px;color:#e91e63">Privacy Policy</h2>
                      <div class="scroll" style="border:2px solid;border-radius:5px;margin:30px;border-color:grey"><br/>
                      <p style="text-align:center">
                          This page sets forth the Privacy Policy of Aimro, and its affiliated companies ("Aimro” or "we" or" us"). 
                          Please read these terms of Use carefully since by visiting and using Aimro and sharing information with our company you agree to be bound by the following terms and conditions unless you offer different terms which are accepted by Aimro in writing.

                      </p>
                      
                      <p style="text-align:center;color:#e91e63">WHY DOES THIS PRIVACY POLICY EXIST?</p>
                      <p style="text-align:center">
                            Our data protection policy is intended to explain the types of personal data collected by Aimro, for which purpose(s) your data is used, and also to explain your rights regarding the collection and processing of this data.
                          </p>

                          <p style="text-align:center;color:#e91e63">WHAT IS PERSONAL DATA?</p>
                      <p style="text-align:center">
                            Data is considered personal if it can be clearly assigned to a specific person or if this assignment is at least implicit, such as information on gender, height, hair color, etc. When booking tickets via Aimro, personal data including, but not limited to, name and e-mail address are used.
                          </p>

                          <p style="text-align:center;color:#e91e63">HOW DOES AIMNROINDIA USE MY PERSONAL DATA?</p>
                      <p style="text-align:center">
                            We only process personal data within the scope of our service offering and only with your consent. Personal data is deleted as soon as it is no longer necessary to achieve the purpose for which it has been collected.
                          </p>

                          <p style="text-align:center;color:#e91e63">DOES AIMRO SHARE PERSONAL DATA WITH THIRD PARTIES?</p>
                      <p style="text-align:center">
                            We will only pass on personal data to third parties if you have expressly consented to the transfer or if we are legally entitled or obliged to do so. We mainly pass on personal data to travel and transport providers to ensure successful bookings and invoices.
                          </p>

                          <p style="text-align:center;color:#e91e63">IS IT SAFE TO STORE MY DATA AT AIMRO?</p>
                      <p style="text-align:center">
                            We take technical and organisational measures to ensure that the data entrusted to us is protected against loss, unauthorized modifications or unauthorised access by third parties. Our security measures are continuously reviewed and updated in line with the latest technological developments and industry standards
                          </p>

                          <p style="text-align:center;color:#e91e63">WHICH RIGHTS DO I HAVE?</p>
                          <p style="padding-left:20px">
                              •	<span style="color:#e91e63">Right to be informed / right of access:</span> You have the right to know why we collect your data, what kind of data we collect and who is the recipient of your data. We also provide you with information about how long and according to which criteria your data is stored, what rights you have with regard to your data and, if we use data from third parties, where the data originates from.
                          </p>
                          <p style="padding-left:20px">
                              •	<span style="color:#e91e63">Right to rectification:</span> We change or supplement incomplete or incorrect data.
                          </p>
                          <p style="padding-left:20px">
                              •	<span style="color:#e91e63">Right to restrict processing:</span> Under various circumstances, for example if you have disagreed with the processing of your data and no final decision has yet been made or while we are reviewing potentially incorrect data, you can request that the processing of your personal data be restricted.
                          </p>
                          <p style="padding-left:20px">
                              •	<span style="color:#e91e63">Right to erasure:</span> In some cases, you have the right to have your data deleted by us - for example, if it is no longer needed for its original purpose, if you have revoked your consent to its use or if the processing of the data was unlawful. Exceptions to this right are made if more important rights (such as freedom of expression) would otherwise be violated.
                          </p>
                          <p style="padding-left:20px">
                              •	<span style="color:#e91e63">Right to data portability:</span> You can request to receive a copy of your data produced in a structured and (mostly) machine-readable format in order to facilitate the transfer of said data to other providers.
                          </p>
                          <p style="padding-left:20px">
                              •	<span style="color:#e91e63">Right to object:</span> You can object to the processing of your data in special cases. If your data would be processed for marketing purposes, you can object at any time and without giving a reason.
                          </p>
                          <p style="padding-left:20px">
                              •	<span style="color:#e91e63">Appeal to a supervisory authority:</span> If you believe that the handling of your data is not lawful, you have the opportunity to file a complaint with a competent supervisory authority, after which you will be informed of the progress and results of the complaint within a reasonable period of time.
                          </p>
                          <p style="text-align:center">
                              At this point, we would like to inform you which data we collect, process and use when using our services, for what purposes and on what legal basis and to whom we provide this data, where applicable.
                          </p>


                          <p style="text-align:center;color:#e91e63">CONTENTS</p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 1.    </span>Scope
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 2.    </span>Controller
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 3.    </span>Data Processing Generally
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 4.    </span>Providing the Website and Creating Logfiles
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 5.    </span>Use of Cookies
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 6.    </span>Newsletter
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 7.    </span>Registration
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 8.    </span>Google Analytics
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 9.    </span>Google Retargeting
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 10.    </span>Google AdSense
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 11.    </span>Google+
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 12.    </span>LinkedIn
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 13.    </span>Twitter
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 14.    </span>Transfer of Data to Third Parties
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 15.    </span>Data Security
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 16.    </span>Your Rights
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 17.    </span>Withdrawal of Consents
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 18.    </span>Contact / Information
                          </p>
                          <br/>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 1.    </span>Use of the Aimro app, collection of personal data when using the Aimro app
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 2.    </span>About App Usage Data Collected by Google Analytics
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 3.    </span>Push Services
                          </p>
                          <p style="padding-left:20px">
                             <span style="color:#e91e63"> 4.    </span>Facebook / Google Login
                          </p>


                          <p style="text-align:center;color:#e91e63">Cookies</p>
                      <p style="text-align:center">
                            Aimro uses cookies, tracking pixels and related technologies. Cookies are small data files that are served by our platform and stored on your device. Our site uses cookies dropped by us or third parties for a variety of purposes including to operate and personalize the website. Also, cookies may also be used to track how you use the site to target ads to you on other websites.
                          </p>


                          <p style="text-align:center;color:#e91e63">Intellectual property rights</p>
                      <p style="text-align:center">
                            The viewing, printing or downloading of any content, text, photography, video, audio, graphic, form or document from Aimro grants you only a revocable, nonexclusive license for use solely by you for personal, noncommercial purposes limited to the use as is reasonably required to view and listen to the content and navigate through the pages and links generally available to the public using a standard Internet browser and standard media player, and not for republication, distribution, assignment, sublicense, sale, preparation of derivative works or other use. No part of any content, text, image, graphic, form or document may be reproduced in any form or incorporated into any information retrieval system, electronic or mechanical, other than for your personal, noncommercial use.
                          </p>

                          <p style="text-align:center;color:#e91e63">Information displayed on the site</p>
                      <p style="text-align:center">
                            Aimro contains texts, images, articles, reviews, discussions, press releases and other information (collectively, "Information") about us, our villas, partners and services, including links to third-party websites that contain such Information, which are being provided as a convenience to visitors of the Site. While all Information prepared by Aimro was believed to be accurate as of the date prepared, we disclaim any duty or obligation to update any Information. You must not treat information on Aimro as comprehensive. Any statements made are based on our best judgment but are subject to a number of uncertainties as well as events beyond our control.
                          </p>

                          <p style="text-align:center;color:#e91e63">Editing, deleting and modification</p>
                      <p style="text-align:center">
                            We reserve the right in our sole discretion to change, edit or delete any documents, information or other content appearing on the Site.
                          </p>

                          <p style="text-align:center;color:#e91e63">Nontransferable</p>
                      <p style="text-align:center">
                            Your right to use Aimro is not transferable. Any password or right given to you to obtain information or documents from the Site is not transferable.
                          </p>

                          <p style="text-align:center;color:#e91e63">Information you send to Aimro</p>
                      <p style="text-align:center">
                            If you send information or material to Aimro by any means or in any way, all such information or material will be treated as non-confidential and non-proprietary, unless otherwise clearly indicated. Aimro may without compensating you in any manner, use such information and material for its own or third parties’ purposes.
                          </p>

                          <p style="text-align:center;color:#e91e63">Links</p>
                      <p style="text-align:center">
                            These Terms of use apply solely to www.aimroindia.com;  www.aimroindia.com contains links to other sites. Please be aware that Aimro is not responsible for the Terms of Use of such other sites. We encourage our users to be aware when they leave our site and to read the Terms of Use statements of each and every web site that they visit.
                          </p>

                          <p style="text-align:center;color:#e91e63">Viruses and harmful code</p>
                      <p style="text-align:center">
                            Aimro assumes no liability whatsoever for damage to or loss of hardware, software or information caused by you downloading Content (and software in particular) from the Site. You must ensure that your computer is adequately protected against computer viruses and harmful code at all times.
                          </p>

                          <p style="text-align:center;color:#e91e63">Limited liability</p>
                      <p style="text-align:center">
                            Aimro IS WITHOUT LIABILITY FOR DAMAGES CAUSED OR ALLEGEDLY CAUSED BY ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DELETION, DEFECT, VIRUS, DELAY IN OPERATION OR TRANSMISSION, INACCURATE INFORMATION, COMMUNICATIONS LINE FAILURE, THEFT OR DESTRUCTION OF OR UNAUTHORIZED ACCESS TO, ALTERATION OF, OR USE OF RECORDS, WHETHER FOR BREACH OF CONTRACT, TORTUOUS BEHAVIOR, NEGLIGENCE, OR UNDER ANY OTHER CAUSE OF ACTION.
                          </p>
                          <p style="text-align:center">
                              Should any provision of this agreement be held to be illegal, invalid, or unenforceable by a court law, the legality, validity and enforceability of the remaining provisions of this agreement shall remain unaffected thereby unless otherwise stated.
                          </p>

                          <p style="text-align:center;color:#e91e63">General and governing law</p>
                      <p style="text-align:center">
                            These Terms of Use shall be governed by and construed in accordance with the laws of India, without reference to its conflicts or choice of laws provision. You consent to the non-exclusive jurisdiction of the Indian courts.
                          </p>
                          <p style="text-align:center">
                              These Terms of Use supersede all previous representations, understandings or agreements and shall prevail notwithstanding any variance with Terms of Use of any order submitted. Use of Aimro constitutes acceptance of our Terms of Use and Privacy Policy.
                          </p>

                          <p style="text-align:center;color:#e91e63">Contacting Aimro</p>
                      <p style="text-align:center">
                            If you have any questions about these terms of use, the practices of this site, or your dealings with this Web site, you can contact us via the contact form on the site or by emailing us at care@aimro.com.
                          </p>

                      <br/>
                      </div>
                  </v-card>
              </v-flex>

              
                         </v-layout>
                         
              </v-container>
    </div>
</template>

<script>
export default {
  data() {
    return {
        
    };
  },
};
</script>

<style scoped>
@import '../../HomeCss/home.css';

@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Bree+Serif|Squada+One&display=swap');
</style>

<style scoped>
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 50px;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.enquiry {
    font-family: 'Bree Serif', serif;
}
.contact_tag {
    font-family: 'Space Mono', monospace;
}
.bckdiv {
    background-image: url("../../assets/contact.jpg");
    background-size: cover;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 300px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            } 
@media screen and (max-width: 763px) {
  .rspnsv {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
    background-position: center;
    background-size: cover;
  }
  .help {
    padding-right: 0px !important;
  }
  .aboutTop {
      margin-top: 180px;
      margin-bottom: 100px;
  }
}
@media screen and (min-width: 768px){
  .xyz {
      height: auto;
  }
}
</style>
